import React from "react";

const ProductIcon = () => (
  <svg className="product-icon" x="0px" y="0px" viewBox="0 0 25 21">
    <g id="Rectangle_70" data-name="Rectangle 70" fill="none" strokeWidth="2">
      <rect width="25" height="21" rx="4" stroke="none" />
      <rect x="1" y="1" width="23" height="19" rx="3" fill="none" />
    </g>
  </svg>
);

export default ProductIcon;
